import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';  
import { RootState } from '../../store/store'; 
import { Box, Container, Typography } from '@mui/material';  
import { FORGOT_PASSWORD_EMAIL, VALIDATION_ERROR_REQUIRED_MESSAGE } from '../../constants/actions';
import { SignInFormStyles } from '../../assets/css/signInForm.styles';  
import { useAppDispatch } from '../../hooks/useAppDispatch';
import CustomTextField from '../../components/customTextField/customTextField';
import CustomButton from '../../components/customButton/customButton';
import Loader from '../../components/loader';
import { forgotPassword } from '../../reducers/authReducer';
import theme from '../../themes/index.en';
import { ArrowBack } from '@mui/icons-material';  


const ForgotPasswordForm: React.FC = () => {
  const [email, setEmail] = useState('');  
  const [touched, setTouched] = useState({ email: false });
  const authState = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => setEmail(event.target.value); 
  
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (email.trim() ==="") { 
        toast.error(FORGOT_PASSWORD_EMAIL);
        return;
    }
    dispatch(forgotPassword({ email })).unwrap()  
    .then((response) => {  
        const { message, success } = response.data;  
        if(success){
            toast.success(`${message}`); 
            navigate('/Signin');
        }
        else{
            toast.error(`${message}`); 
        }  
    }).catch((error) => {
         if (error.response && error.response.data && error.response.data.message) {
            toast.error(error.response.data.message);
        } else {
            toast.error("An unexpected error occurred. Please try again."); 
        }
    }); 
  };

  return (
    <Container component="main" maxWidth="sm" sx={SignInFormStyles.container}> 
        {authState.isLoading && <Loader />} 
        <div> 
          <Typography variant="h5" component="h2" align="center" sx={{ marginBottom: "25px" }}>
            Please enter your email to proceed with the password recovery process
          </Typography>
        </div>  
        <Box component="form" onSubmit={handleSubmit} noValidate style={SignInFormStyles.form}>
          <CustomTextField
            label="Email"
            name="email"
            type="text"
            value={email}
            onChange={handleEmailChange}
            required={true}
            autoFocus={true}
            error={touched.email && email === ''}
            helperText={touched.email && email === '' ? `${VALIDATION_ERROR_REQUIRED_MESSAGE}` : ''}
          />  
          <CustomButton 
            type="submit" 
            style={authState.isLoading ? SignInFormStyles.disableButton : SignInFormStyles.button}
          >
            Continue
          </CustomButton> 
        </Box>  
 
        <Typography variant="body2" align="center" sx={{ marginTop: "15px" }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <ArrowBack fontSize="small" sx={{ marginRight: "5px" }} />
            <Link to="/Signin" style={{ color: theme.palette.text.primary, fontWeight: "bold", textDecoration: "none" }}>
              Back to Sign In
            </Link>
          </Box>
        </Typography> 
    </Container>
  );
};

export default ForgotPasswordForm;
